import { gql } from "@apollo/client";

export const GET_SELLER_TRANSACTION_TOTALS = gql`
  query SellerTransactionTotals {
    sellerTransactions(
      pageSize: 1
      currentPage: 1
    ) {
      order_totals {
        total_sales
        total_commission
        total_earnings
        total_withdrawal
        total_payment
      }
    }
  }
`;
